import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, ShieldCheckIcon, DollarSignIcon } from 'lucide-react';
export function ValueProp() {
  return <section className="px-6 pb-24 bg-white" data-id="element-230">
      <div className="max-w-7xl mx-auto" data-id="element-231">
        <div className="bg-espresso text-alabaster p-8 md:p-20 border-3 border-charcoal shadow-[12px_12px_0px_0px_rgba(26,26,26,1)] md:shadow-[16px_16px_0px_0px_rgba(26,26,26,1)]" data-id="element-232">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-233">
            <div data-id="element-234">
              <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-235">
                Luxury Craftsmanship, <br data-id="element-236" />
                <span className="italic font-serif font-normal" data-id="element-237">
                  Without the Luxury Price Tag.
                </span>
              </h2>
              <p className="text-alabaster/80 text-lg mb-12 leading-relaxed" data-id="element-238">
                NK Refacers delivers a brand-new kitchen aesthetic using your
                existing structural footprint. We eliminate the demolition
                phase, saving you thousands while maintaining uncompromising
                quality.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-239">
                <div className="flex gap-4" data-id="element-240">
                  <div className="bg-alabaster/10 p-3 h-fit" data-id="element-241">
                    <ClockIcon className="w-6 h-6" data-id="element-242" />
                  </div>
                  <div data-id="element-243">
                    <h4 className="font-bold mb-1" data-id="element-244">48-Hour Turnaround</h4>
                    <p className="text-sm text-alabaster/60" data-id="element-245">
                      Back in your kitchen by dinner.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-246">
                  <div className="bg-alabaster/10 p-3 h-fit" data-id="element-247">
                    <ShieldCheckIcon className="w-6 h-6" data-id="element-248" />
                  </div>
                  <div data-id="element-249">
                    <h4 className="font-bold mb-1" data-id="element-250">Zero Mess Policy</h4>
                    <p className="text-sm text-alabaster/60" data-id="element-251">
                      No demolition or structural dust.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-alabaster text-charcoal p-10 border-3 border-charcoal space-y-8" data-id="element-252">
              <div className="flex items-center gap-4 border-b-2 border-charcoal/10 pb-6" data-id="element-253">
                <DollarSignIcon className="w-8 h-8 text-espresso" data-id="element-254" />
                <div data-id="element-255">
                  <h3 className="text-2xl font-bold" data-id="element-256">Transparent Pricing</h3>
                  <p className="text-sm text-charcoal/60" data-id="element-257">
                    No upselling. No hidden fees.
                  </p>
                </div>
              </div>
              <ul className="space-y-4" data-id="element-258">
                {['Custom-Made Door Fronts', 'High-Pressure Matching Veneers', 'Soft-Close Hardware Included', 'Professional Installation'].map((item, i) => <li key={i} className="flex items-center gap-3 font-medium" data-id="element-259">
                    <div className="w-2 h-2 bg-espresso" data-id="element-260" />
                    {item}
                  </li>)}
              </ul>
              <Link to="/get-quote" className="w-full bg-charcoal text-alabaster py-5 font-bold uppercase tracking-widest hover:bg-espresso transition-colors text-center block" data-id="element-261">
                Claim Your 50% Savings
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}